export const ORIGIN = {
  ALL: 'all',
  OWN: 'own',
  SHARED: 'shared',
};

export const BREAKPOINTS = {
  ALL: {
    FOR_PHONE_ONLY: 'for-phone-only',
    FOR_TABLET_PORTRAIT: 'for-tablet-portrait',
    FOR_TABLET_LANDSCAPE: 'for-tablet-landscape',
    FOR_DESKTOP: 'for-desktop',
    FOR_BIG_DESKTOP: 'for-big-desktop',
  },
  PHONE_AND_TABLET: ['for-phone-only', 'for-tablet-portrait', 'for-tablet-landscape'],
  DESKTOP: ['for-desktop', 'for-big-desktop'],
};

export const SUBSCRIPTION_PLAN_TYPE = {
  STANDARD: 'standard',
  TRIAL: 'trial',
  PLATFORM: 'platform',
  PERSONAL: 'personal',
};

export const INSTANCE_REGISTRATION_CODE = {
  INSTANCE_REGISTRATION_TRIAL_STARTED: 'instance_registration_trial_started',
  INSTANCE_REGISTRATION_PAYMENT_CHARGE_FAILED: 'instance_registration_payment_charge_failed',
  INSTANCE_REGISTRATION_PAYMENT_SOURCE_PENDING: 'instance_registration_payment_source_pending',
  INSTANCE_REGISTRATION_PAYMENT_CHARGE_PENDING: 'instance_registration_payment_charge_pending',
  INSTANCE_REGISTRATION_PAYMENT_CHARGE_SUCCEEDED: 'instance_registration_payment_charge_succeeded',
  INSTANCE_REGISTRATION_BANK_TRANSFER_PENDING: 'instance_registration_bank_transfer_pending',
};

export const INST_PLAN_PURCHASE_CODE = {
  // check (before checkout) - not ok
  PLAN_PURCHASE_FAILED_PAYMENT_EXISTS: 'plan_purchase_failed_payment_exists',
  PLAN_PURCHASE_ENQUEUED_EXISTS: 'plan_purchase_enqueued_exists',
  PLAN_PURCHASE_PENDING_PAYMENT_EXISTS: 'plan_purchase_pending_payment_exists',
  // check (before checkout) - ok
  PLAN_PURCHASE_NO_CURRENT: 'plan_purchase_no_current',
  PLAN_PURCHASE_ON_TRIAL: 'plan_purchase_on_trial',
  PLAN_PURCHASE_CURRENT_EXISTS: 'plan_purchase_current_exists',
  // after checkout
  PLAN_PURCHASE_PAYMENT_CHARGE_FAILED: 'plan_purchase_payment_charge_failed',
  PLAN_PURCHASE_PAYMENT_SOURCE_PENDING: 'plan_purchase_payment_source_pending', // with redirect_url
  PLAN_PURCHASE_PAYMENT_CHARGE_PENDING: 'plan_purchase_payment_charge_pending',
  PLAN_PURCHASE_PAYMENT_CHARGE_SUCCEEDED: 'plan_purchase_payment_charge_succeeded',
  PLAN_PURCHASE_BANK_TRANSFER_PENDING: 'plan_purchase_bank_transfer_pending',
};

export const INVITATION_TYPE = {
  PARTICIPANT: 'participant',
  TEAM_MEMBER: 'team_member',
};

export const TAX = {
  EU: 21,
};

export const PAYMENT_METHOD = {
  SAVED_SOURCE: 'saved_source',
  STRIPE_SOURCE: 'stripe_source',
  BANK_TRANSFER: 'bank_transfer',
};

export const NUTRITION_FACTS_LABEL_FORMAT = {
  EUROPEAN: 'european',
  AMERICAN: 'american',
};

export const PERSON_MEASUREMENTS_TOTAL = 100;

export const REGISTRATION_STATUS = {
  AVAILABLE: [
    'instance_registration_new',
    'instance_registration_resume',
    'instance_registration_transfer',
    'instance_registration_reserved',
  ],
  NOT_AVAILABLE: [
    'instance_registration_subdomain_not_available',
    'instance_registration_email_not_available',
    'instance_registration_email_not_available_pending',
    'instance_registration_email_not_available_transferable',
    'instance_registration_already_registered_pending',
  ],
};

// *** registracija, prethodne provere - ok:
// instance_registration_new
// instance_registration_resume
// instance_registration_transfer
// instance_registration_reserved

// *** registracija, prethodne provere - nije ok:
// instance_registration_subdomain_not_available
// instance_registration_email_not_available
// instance_registration_email_not_available_pending
// instance_registration_email_not_available_transferable
// instance_registration_already_registered_pending

// *** nakon checkout-a:
// instance_registration_trial_started
// instance_registration_payment_source_pending (ide uz to i redirect_url)
// instance_registration_payment_charge_pending
// instance_registration_payment_charge_succeeded
// instance_registration_payment_charge_failed



// WEBPACK FOOTER //
// ./src/constants/values.js